/* Spider-Kody · perchero interactivo */
(() => {
  const root = document.querySelector('[data-skr]');
  if (!root || root.__skr) return; root.__skr = 1;
  const data = JSON.parse(root.querySelector('[data-skr-json]').textContent || '[]');
  const detail = root.querySelector('[data-detail]');
  const papers = [...root.querySelectorAll('[data-paper]')];
  const tags = [...root.querySelectorAll('[data-tag]')];
  const sides = [...root.querySelectorAll('[data-side]')];
  const faces = root.querySelector('.skr__faces');
  const front = root.querySelector('[data-front]'), back = root.querySelector('[data-back]'), wipe = root.querySelector('[data-wipe]');
  let cur = -1, side = 'front', lastBtn = null, wipeT = 0;
  // el modal vive fuera del flujo para cubrir la cabecera
  document.body.appendChild(detail);

  if (matchMedia('(hover: none)').matches) { const h = root.querySelector('.skr__hint'); if (h) h.textContent = 'Toca una camiseta para verla de cerca'; }
  const preload = () => data.forEach((d) => { new Image().src = d.front; new Image().src = d.back; });
  const setPaper = (i) => papers.forEach((p, k) => { p.classList.toggle('is-on', k === i); });
  const setTags = (i) => tags.forEach((t, k) => t.classList.toggle('is-on', k === i));
  const setSide = (s) => { side = s; faces.classList.toggle('is-back', s === 'back'); sides.forEach((b) => b.classList.toggle('is-on', b.dataset.side === s)); };

  function open(i, fromImg) {
    cur = i; front.src = data[i].front; back.src = data[i].back;
    setSide('front'); setPaper(i); setTags(i);
    root.classList.add('is-open'); detail.classList.add('is-open'); document.documentElement.classList.add('skr-lock');
    if (fromImg && faces.animate) {
      requestAnimationFrame(() => {
        const a = fromImg.getBoundingClientRect(), b = faces.getBoundingClientRect();
        if (!b.width) return;
        faces.animate([
          { transform: `translate(${a.left - b.left}px, ${a.top - b.top}px) scale(${a.width / b.width}) rotateY(40deg)`, transformOrigin: '0 0' },
          { transform: 'none', transformOrigin: '0 0' },
        ], { duration: 750, easing: 'cubic-bezier(.2,.9,.2,1)' });
      });
    }
    preload();
    detail.querySelector('[data-close]').focus({ preventScroll: true });
  }
  function close() {
    root.classList.remove('is-open'); detail.classList.remove('is-open'); document.documentElement.classList.remove('skr-lock');
    if (lastBtn) lastBtn.focus({ preventScroll: true });
  }
  function swap(i) {
    if (i === cur || i < 0 || i >= data.length) return;
    cur = i; setPaper(i); setTags(i);
    clearTimeout(wipeT);
    wipe.src = data[i][side];
    wipe.classList.remove('go'); void wipe.offsetWidth; wipe.classList.add('go');
    wipeT = setTimeout(() => { front.src = data[i].front; back.src = data[i].back; wipe.classList.remove('go'); }, 620);
  }

  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-open]');
    if (b) { lastBtn = b; open(+b.dataset.open, b.querySelector('.skr__tee')); }
  });
  detail.addEventListener('click', (e) => {
    const t = e.target;
    if (t === detail) return close();
    const tg = t.closest('[data-tag]'); if (tg) return swap(+tg.dataset.tag);
    const sd = t.closest('[data-side]'); if (sd) return setSide(sd.dataset.side);
    if (t.closest('[data-close]')) return close();
  });
  document.addEventListener('keydown', (e) => {
    if (!detail.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') swap((cur + 1) % data.length);
    else if (e.key === 'ArrowLeft') swap((cur - 1 + data.length) % data.length);
    else if (e.key === 'f' || e.key === 'F') setSide(side === 'front' ? 'back' : 'front');
  });
  // deslizar en móvil para cambiar de universo
  let sx = null;
  faces.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
  faces.addEventListener('touchend', (e) => {
    if (sx == null) return; const dx = e.changedTouches[0].clientX - sx; sx = null;
    if (Math.abs(dx) > 50) swap((cur + (dx < 0 ? 1 : -1) + data.length) % data.length);
    else setSide(side === 'front' ? 'back' : 'front');
  });
  // abrir directamente con #negative, #classic…
  const fromHash = () => { const h = location.hash.slice(1).toLowerCase(); const i = [...root.querySelectorAll('[data-open]')].findIndex((b) => (b.getAttribute('aria-label') || '').toLowerCase().replace(/\s+/g, '-').endsWith(h)); if (h && i >= 0) open(i); };
  fromHash();
})();
